import { LoanOfferViewModel } from "@cxm/client";
import z from "zod";
import { LoanType } from "@cxm/client";

export const offerModel = z.object({
  loanType: z.nativeEnum(LoanType),
  loanAmount: z.number(),
  rate: z.number(),
  maturity: z.number(),
  monthlyPayment: z.number(),
  amortization: z.number(),
  originationFees: z.number(),
  cxmOriginationFees: z.number().optional(),
  backEndFees: z.number(),
  applicationFees: z.number(),
  earlyTerminationFees: z.number(),
  isBinding: z.boolean(),
  covenants: z.number().array(),
  collaterals: z.number().array(),
  personalGuarantee: z.boolean(),
  targetCloseDate: z.number(),
  bindingFiles: z.string().array(),
  nonBindingFiles: z.string().array(),
  cxmFixedOriginationFees: z.number(),
});

export const totalCashFees = (offer: LoanOfferViewModel) => {
  var amount = offer.loanAmount ?? 0;
  var originFeesRate = (offer.originationFees ?? 0) / 100;
  var appFees = offer.applicationFees ?? 0;
  var defaultFeesRate = 0.01;
  var backendFeesRate = (offer.backEndFees ?? 0) / 100;

  return Math.round(
    (amount * originFeesRate) + (amount * defaultFeesRate) +
    (amount * backendFeesRate) + appFees,
  );
};

export const totalPercentFees = (offer: LoanOfferViewModel) => {
  return Math.round((totalCashFees(offer) / (offer.loanAmount ?? 0.01)) * 100);
};
